
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weekly-ranking-articles",
      function () {
        return require("private-next-pages/weekly-ranking-articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weekly-ranking-articles"])
      });
    }
  